import PropTypes from 'prop-types';
import imageHelper from '@utils/imageHelper';
import { breakpoints } from '@styles/index';
import styled from 'styled-components';
import Container, { Title, Description } from './styles';

const BackGroundImage = styled.div`
  background-color: #fcfcfc;
  padding-top: 96px;
  padding-bottom: 0px;
  @media (max-width: ${breakpoints.tablet}) {
    padding-top: 40px;
    padding-bottom: 0;
    width: 728px;
    margin: auto;
  }
  @media (max-width: ${breakpoints.mobile}) {
    padding: 40px 0px 80px;
    width: 100%;
  }
`;

const StyledContainer = styled(Container)`
  place-items: center;
  @media (max-width: ${breakpoints.mobile}) {
    display: flex;
    flex-flow: column-reverse;
  }
`;

const LeftSection = styled.section`
  grid-column: 1/9;
  @media (max-width: ${breakpoints.tablet}) {
    grid-column: 1/12;
  }
  @media (max-width: ${breakpoints.mobile}) {
    margin-top: 38px;
    padding: 0 16px;
  }
`;

const Header = styled(Title)`
  line-height: 120%;
  margin-bottom: 16px;
  @media (max-width: ${breakpoints.mobile}) {
    font-size: 24px;
    margin-bottom: 8px;
  }
`;

const Content = styled(Description)`
  margin-bottom: 40px;
  line-height: 150%;
  @media (max-width: ${breakpoints.mobile}) {
    font-size: 16px;
    margin-bottom: 24px;
  }
`;

const RightSection = styled.img`
  grid-column: 11/25;
  object-fit: cover;
  cursor: pointer;
  user-drag: none;
  user-select: none;
  @media (max-width: ${breakpoints.tablet}) {
    grid-column: 13/25;
    height: 384px;
  }
  @media (max-width: ${breakpoints.mobile}) {
    width: 100%;
    height: 300px;
  }
`;

const Grid = styled.div`
  grid-column: 1/8;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 16px;
  place-items: flex-start;
`;

const StyledA = styled.a`
  height: 48px;
  border-radius: 8px;
  overflow: hidden;
  width: 162px;
  @media (max-width: ${breakpoints.mobile}) {
    width: 156px;
  }
`;

const StyledImage = styled.img`
  object-fit: cover;
  cursor: pointer;
  user-drag: none;
  user-select: none;
`;

function Download({ data }) {
  const { title, subTitle, urls } = data;
  return (
    <BackGroundImage>
      <StyledContainer>
        <LeftSection>
          <Header>{title}</Header>
          <Content>{subTitle}</Content>
          <Grid>
            <StyledA
              href="https://apps.apple.com/in/app/unacademy-learning-app/id1342565069?referrer%3Dutm_source%253Dk12%2526utm_medium%253DWebApp%2526utm_campaign%253Dk12%2526"
              rel="noopener noreferrer"
              target="_blank"
            >
              <StyledImage
                src={imageHelper.getImage('k12/app_store.png')}
                width="100%"
                height="100%"
                alt="apple store app download"
                loading="lazy"
              />
            </StyledA>
            <StyledA
              href="https://play.google.com/store/apps/details?id=com.unacademyapp&referrer=utm_source%3Dk12%26utm_medium%3DWebApp%26utm_campaign%3Dk12%26"
              rel="noopener noreferrer"
              target="_blank"
            >
              <StyledImage
                src={imageHelper.getImage('k12/play_store.png')}
                width="100%"
                height="100%"
                alt="playstore app download"
                loading="lazy"
              />
            </StyledA>
          </Grid>
        </LeftSection>
        <RightSection src={urls} alt="learn" width="100%" height="auto" />
      </StyledContainer>
    </BackGroundImage>
  );
}

Download.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired
};

export default Download;
